A human-readable description of the pay type.
